"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const matrix1 = [
    '#00374B',
    '#004B63',
    '#00728B',
    '#038DBB',
    '#00A2D8',
    '#00C7FF',
    '#55D6FE',
    '#90E4FE',
    '#CAF2FE',
];
const matrix2 = [
    '#001E5A',
    '#013078',
    '#0142A6',
    '#0057D5',
    '#0460FF',
    '#3689FF',
    '#75A7FE',
    '#AAC4FD',
    '#D4E4FB',
];
const matrix3 = [
    '#12053D',
    '#180B51',
    '#2C1378',
    '#391B95',
    '#4A24B7',
    '#5A32EB',
    '#854FFB',
    '#B28CFB',
    '#DACAFB',
];
const matrix4 = [
    '#2E0843',
    '#450F5D',
    '#63167E',
    '#77239D',
    '#9A2ABA',
    '#BC37F2',
    '#D456FF',
    '#E395FB',
    '#F1C9FE',
];
const matrix5 = [
    '#3F051B',
    '#551126',
    '#7A193C',
    '#97274F',
    '#BB2A61',
    '#E73A79',
    '#EF6F9F',
    '#F6A3BF',
    '#F8D4E0',
];
const matrix6 = [
    '#5B0601',
    '#830D00',
    '#B51902',
    '#E12300',
    '#FE4310',
    '#FE634D',
    '#FF8C85',
    '#FCB5AF',
    '#FFD8D9',
];
const matrix7 = [
    '#591C00',
    '#792A01',
    '#AC3F00',
    '#DC5100',
    '#FD6B00',
    '#FF8448',
    '#FFA47D',
    '#FFC4A8',
    '#FEE2D6',
];
const matrix8 = [
    '#583400',
    '#794803',
    '#AB6702',
    '#D38306',
    '#FFAA00',
    '#FFB23C',
    '#FFC878',
    '#FFD8A8',
    '#FFEBD3',
];
const matrix9 = [
    '#553D00',
    '#765700',
    '#A57C00',
    '#D5A209',
    '#FFC501',
    '#FFC940',
    '#FED374',
    '#FDE5A7',
    '#FEF3D5',
];
const matrix10 = [
    '#666002',
    '#888901',
    '#C2BD00',
    '#F4ED01',
    '#FDFB44',
    '#FBF968',
    '#FDFA91',
    '#FFFCB5',
    '#FFFCDB',
];
const matrix11 = [
    '#505600',
    '#717507',
    '#9CA50C',
    '#C6CE16',
    '#D8EB37',
    '#E4EF62',
    '#EBF38E',
    '#F1F7B7',
    '#F9F9DD',
];
const matrix12 = [
    '#283E0F',
    '#3B571C',
    '#4C7C28',
    '#649C31',
    '#75BA43',
    '#97D45F',
    '#B0DC87',
    '#CDE9B8',
    '#E2EBDA',
];
const colorMatrix = [
    matrix1,
    matrix2,
    matrix3,
    matrix4,
    matrix5,
    matrix6,
    matrix7,
    matrix8,
    matrix9,
    matrix10,
    matrix11,
    matrix12,
];
module.exports = colorMatrix;
